var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.franquiasEnabled)?_c('franquia'):_c('home-app')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }